import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import Loading from "../../loader/loader.js";
import NkHeader from "../../../common/nkheader";
import NkTable from "../nktable";
import "./nonRegisterUser.scss";

const NonRegisterUsersPresentational = ({
  searchBy,
  setSearchByValueHandler,
  setSearchBy,
  searchByValue,
  handleFIlter,
  allUserList,
  nonRegUsersLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  allUserListExcel,
  columns,
  columnsCsv,
  setFilterForm,
  setSizeShow,
  rowOnClick,
  searchErrorText,
  setSearchErrorText,
}) => {
  const getPlaceholderText = () => {
    if (searchBy === "citizenId") {
      return "784xxxxxxxxxxxx";
    } else if (searchBy === "corporateId") {
      return "99999";
    } else if (searchBy === "emiratesId") {
      return "784xxxxxxxxxxxx";
    } else if (searchBy === "cardSerialNumber") {
      return "1234567890";
    } else if (searchBy === "mobileNumber") {
      return "00971xxxxxxxxx";
    } else if (searchBy === "name") {
      return "Ahmed";
    } else {
      return "971xxxxxxxxx";
    }
  };

  const getMaxLength = () => {
    if (searchBy === "citizenId") {
      return 15;
    } else if (searchBy === "corporateId") {
      return 6;
    } else if (searchBy === "emiratesId") {
      return 15;
    } else if (searchBy === "cardSerialNumber") {
      return 10;
    } else if (searchBy === "mobileNumber") {
      return 14;
    } else {
      return;
    }
  };
  return (
    <>
      <Container fluid className="non-register-user-container">
        <NkHeader title="Non Registered Users" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search by
                  </label>
                  <Input
                    id="exampleFormControlSelect1"
                    type="select"
                    value={searchBy}
                    style={{ height: "27px" }}
                    onChange={(e) => {
                      setSearchByValueHandler("");
                      setSearchBy(e.target.value);
                      setSearchErrorText("");
                    }}
                  >
                    <option value="mobileNumber">Mobile</option>
                    <option value="name">Name</option>
                    <option value="citizenId">CT ID</option>
                    {/* <option value="corporateId">Branch ID</option> */}
                    <option value="emiratesId">Emirates ID</option>
                    <option value="cardSerialNumber">Card Serial</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search for
                  </label>
                  <Input
                    id="example3cols2Input"
                    style={{ height: "27px" }}
                    placeholder={getPlaceholderText()}
                    type="text"
                    maxLength={getMaxLength()}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        handleFIlter();
                      }
                    }}
                    onChange={(e) => {
                      setSearchByValueHandler(e.target.value && e.target.value);
                    }}
                    value={searchByValue}
                  />
                  <p className="searchfor-error-message">
                    {searchErrorText || ""}
                  </p>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "9px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => {
                        handleFIlter();
                      }}
                    >
                      <div>
                        <i class="fas fa-search"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row>
          <div className="col card-parent">
            <Card style={{ padding: "1.25rem 1.5rem" }}>
              {nonRegUsersLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Loading />
                </div>
              ) : (
                <>
                  <NkTable
                    dataexcal={false}
                    filename={"All-User-List"}
                    data={allUserList}
                    rowOnClick={rowOnClick}
                    buttonRef={buttonRef}
                    type="alluser"
                    filterdata={filterForm}
                    onExcelClciked={() => onExcelClciked(filterForm)}
                    dataEXCEL={allUserListExcel}
                    columns={columns}
                    columnsCsv={columnsCsv}
                    onPagechange={(page) => {
                      setFilterForm({
                        ...filterForm,
                        page: page,
                      });
                    }}
                    showSizeChanged={(pageSize) => {
                      setSizeShow(pageSize);
                      setFilterForm({
                        ...filterForm,
                      });
                    }}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default NonRegisterUsersPresentational;
